const SearchBar = () => {
  return (
    <div className="search-wrapper">
      <div className="search-box">
        <input
          type="text"
          placeholder="Search for help topics, articles, and FAQs..."
        />
      </div>
    </div>
  );
};

export default SearchBar;
